import { Params } from '@angular/router';

import { LogicalErrorDocumentType } from 'app/shared/constants/logical-error-document-type';

export const REMEDIATION_ROUTE = {
  DEFAULT: '',
  DOCUMENT: {
    name: ':documentType',
    queryParams(classId: string, localeId?: string): Params {
      const params: Params = { ClassId: encodeURI(classId) };

      if (localeId) {
        params.localeId = encodeURI(localeId);
      }

      return params;
    },
    route(logicalErrorId: string, documentType: LogicalErrorDocumentType): string[] {
      return [...REMEDIATION_ROUTE.route(logicalErrorId), documentType];
    }
  },
  name: 'remediation/:logicalErrorId',
  REMEDIATION: {
    name: 'remediation/:logicalErrorId',
    route(logicalErrorId: string): string[] {
      return ['/remediation', logicalErrorId];
    }
  },
  REMEDIATION_DOCUMENT: {
    name: 'remediation/:logicalErrorId/:documentType',
    queryParams(classId: string, localeId?: string): Params {
      const params: Params = { ClassId: encodeURI(classId) };

      if (localeId) {
        params.localeId = encodeURI(localeId);
      }

      return params;
    },
    route(logicalErrorId: string, documentType: LogicalErrorDocumentType): string[] {
      return ['/remediation', logicalErrorId, documentType];
    }
  },
  route(logicalErrorId: string): string[] {
    return ['/remediation', logicalErrorId];
  }
};
